import React from "react";

// Official TBS logo (provided by client)
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_build-secure-hub/artifacts/uonsmudz_logo-Photoroom.png";

/**
 * TBS official logo.
 * - variant="default": light backgrounds (paper / cream / white)
 * - variant="light":   dark backgrounds (navy footer) — uses mix-blend + filter
 *                       to lift navy strokes into a light visible color while
 *                       keeping the gold accents.
 *
 * `showWordmark` is kept for API compatibility but is ignored because the
 * official logo file already includes the "TBS / Turkish Business Services"
 * wordmark.
 */
export const TbsLogo = ({
  className = "h-10 w-auto",
  // eslint-disable-next-line no-unused-vars
  showWordmark = false,
  variant = "default",
}) => {
  const isLight = variant === "light";

  return (
    <div className="inline-flex items-center" data-testid="tbs-logo">
      <img
        src={LOGO_URL}
        alt="TBS · Turkish Business Services"
        loading="eager"
        decoding="async"
        className={`${className} object-contain select-none`}
        style={
          isLight
            ? {
                // Brighten the navy strokes against a dark background while
                // keeping cream paper background visually neutral.
                mixBlendMode: "screen",
                filter: "brightness(1.15) contrast(1.05)",
              }
            : undefined
        }
        draggable={false}
      />
    </div>
  );
};

export default TbsLogo;
